import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
export const MonthWiseReport=() =>{
  
  return (
    <>
    <MainDiv>
    {/* <MainContent/>         */}
    <DateWiseSearch />
   </MainDiv> 
    </>
    
  )
}
